import React, { useEffect, useState } from "react";
import "./Vehicle.scss";
import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import {
  addNewVehicle,
  editVehicle,
  fetchVehicleById,
  fetchVehicleGroup,
} from "../../store/slices/Vehicle/thunk";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast,ToastContainer } from "react-toastify";
import { storage } from "../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { fetchCompany } from "../../store/slices/thunk";
import { getTenantConfigFromStorage } from "../../helpers/tenantConfig";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { MdDelete } from "react-icons/md";

const carColors = [
  { name: "Black", value: "#000000" },
  { name: "White", value: "#FFFFFF" },
  { name: "Silver", value: "#C0C0C0" },
  { name: "Gray", value: "#808080" },
  { name: "Red", value: "#FF0000" },
  { name: "Blue", value: "#0000FF" },
  { name: "Green", value: "#008000" },
  { name: "Yellow", value: "#FFFF00" },
  { name: "Pearl White", value: "#F8F8FF" },
  { name: "Champagne Gold", value: "#D4AF37" },
  { name: "Gunmetal Gray", value: "#2C3539" },
  { name: "Titanium Silver", value: "#BFC1C2" },
  { name: "Space Gray", value: "#4A4A4A" },
  { name: "Graphite", value: "#383838" },
  { name: "Charcoal", value: "#333333" },
  { name: "Racing Red", value: "#C00000" },
  { name: "Bright Orange", value: "#FF4500" },
  { name: "Lime Green", value: "#32CD32" },
  { name: "Electric Blue", value: "#1E90FF" },
  { name: "Sky Blue", value: "#87CEEB" },
  { name: "Sunburst Yellow", value: "#FFD300" },
  { name: "Maroon", value: "#800000" },
  { name: "Navy Blue", value: "#000080" },
  { name: "Olive", value: "#808000" },
  { name: "Beige", value: "#F5F5DC" },
  { name: "Brown", value: "#8B4513" },
  { name: "Bronze", value: "#CD7F32" },
  { name: "Steel Blue", value: "#4682B4" },
  { name: "Platinum Silver", value: "#E5E4E2" },
  { name: "Magnetic Gray", value: "#5C5C5C" },
  { name: "Glacier White", value: "#F0F0F0" },
  { name: "Midnight Black", value: "#1C1C1C" },
  { name: "Desert Sand", value: "#CDB79E" },
  { name: "Pearl Blue", value: "#3B83BD" },
  { name: "Pearl Red", value: "#B22222" },
  { name: "Matte Black", value: "#1A1A1A" },
  { name: "Matte Gray", value: "#555555" },
  { name: "Rose Gold", value: "#B76E79" },
  { name: "Copper", value: "#B87333" },
  { name: "Teal", value: "#008080" },
  { name: "Aqua", value: "#00FFFF" },
  { name: "Indigo", value: "#4B0082" },
  { name: "Violet", value: "#8A2BE2" },
];

const textFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#fff",
    height: "46px",
    "& fieldset": {
      borderColor: "#d0d5dd",
    },
    "&:hover fieldset": {
      borderColor: "#7c6dff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#7c6dff",
    },
  },
};

const selectSx = {
  ...textFieldSx,
  "& .MuiOutlinedInput-root": {
    ...textFieldSx["& .MuiOutlinedInput-root"],
    height: "46px",
  },
};

const FormLabel = ({ label, required }: { label: string; required?: boolean }) => (
  <Typography
    variant="body2"
    sx={{
      fontWeight: 600,
      color: "#344054",
      fontSize: "0.85rem",
      mb: 0.75,
    }}
  >
    {label}
    {required && <Box component="span" sx={{ color: "#ef4444", ml: 0.5 }}>*</Box>}
  </Typography>
);

const UploadBox = ({
  icon,
  title,
  subtitle,
  onClick,
  disabled,
}: {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  onClick?: () => void;
  disabled?: boolean;
}) => (
  <Box
    onClick={onClick}
    sx={{
      border: "2px dashed #d0d5dd",
      borderRadius: "10px",
      p: 3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: onClick ? "pointer" : "default",
      backgroundColor: "#fafbfc",
      minHeight: 120,
      transition: "all 0.2s",
      opacity: disabled ? 0.6 : 1,
      "&:hover": onClick
        ? {
            borderColor: "#7c6dff",
            backgroundColor: "#f5f3ff",
          }
        : {},
    }}
  >
    <Box sx={{ mb: 1, color: "#98a2b3" }}>{icon}</Box>
    <Typography
      variant="body2"
      sx={{ fontWeight: 600, color: "#344054", fontSize: "0.8rem" }}
    >
      {title}
    </Typography>
    <Typography variant="caption" sx={{ color: "#98a2b3", fontSize: "0.7rem" }}>
      {subtitle}
    </Typography>
  </Box>
);

const AddVehicle = () => {
  const tenantConfig = getTenantConfigFromStorage();
  const schoolLabel = tenantConfig.labels.school;
  const [selectTraccarDeviceID, setSelectTraccarDeviceID] = useState("");
  const [selectvehicleType, setSelectselectvehicleType] = useState("");
  const [addVehicle, setAddVehicle] = useState({
    registrationNumber: "",
    vehicleName: "",
    model: "",
    chassisNo: "",
    engineNo: "",
    manufacturedBy: "",
    vehicleType: "",
    vehicleColor: "",
    vehicleImage: "",
    vehicleDocument: "",
    vehicleTraccarDeviceId: "",
    company: {
      companyId: "",
      companyName: "",
    },
    localvideoUrl: "",
    _id: "",
  });
  const dispatch: any = useDispatch();
  const [getAllVehicleGroup, setAllVehicleGroup] = useState([]);
  const [page, setPage] = useState(1);
  const { id } = useParams<any>();
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const [searchVehicleGroup, setSearchVehicleGroup] = React.useState("");
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500;
  const ITEMS_PER_PAGE = 10;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [searchCompany, setSearchCompany] = React.useState("");
  const [companyId, setCompanyId] = useState<string>("");
  const [allCompany, setAllCompany] = useState<any>([]);

  const handleChangeForVehicleType = (event: any) => {
    setAddVehicle({
      ...addVehicle,
      vehicleType: event.target.value,
    });
  };
  const REGEX = /^(?:[A-Z]{3}-\d{3,4}|[A-Z]{3}\s\d{3,4}|\d{3,7})$/;
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "registrationNumber") {
      const formatted = value.toUpperCase();
      setAddVehicle({ ...addVehicle, registrationNumber: formatted });
      return;
    }

    setAddVehicle({
      ...addVehicle,
      [name]: value,
    });
    setAddVehicle((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    const handler = setTimeout(async () => {
      const response = await dispatch(
        fetchVehicleGroup(1, 10, searchVehicleGroup)
      );
      if (
        response &&
        response?.data &&
        response?.data?.data &&
        response?.data?.data?.length &&
        response?.isSuccess
      ) {
        setAllVehicleGroup(response?.data?.data);
        setTotalCount(response?.data?.totalCount);
      } else {
        setAllVehicleGroup([]);
        setTotalCount(0);
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    };
  }, [searchVehicleGroup, dispatch]);

  useEffect(() => {
    const getAllCompany = async () => {
      const response: any = await dispatch(
        fetchCompany(1, 99999999, searchCompany, "")
      );
      if (response && response?.data?.data?.length > 0 && response?.isSuccess) {
        setAllCompany(response?.data?.data);
      } else {
        setAllCompany([]);
      }
    };
    getAllCompany();
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsEdit(true);
        const response: any = await dispatch(fetchVehicleById(id));
        setAddVehicle(response?.data);
        navigate(`/edit-vehicle/${id}`);
      } else {
        setIsEdit(false);
        setAddVehicle({
          registrationNumber: "",
          vehicleName: "",
          model: "",
          chassisNo: "",
          engineNo: "",
          manufacturedBy: "",
          vehicleType: "",
          vehicleColor: "",
          localvideoUrl: "",
          vehicleImage: "",
          vehicleDocument: "",
          vehicleTraccarDeviceId: "",
          company: {
            companyId: "",
            companyName: "",
          },
          _id: "",
        });
        navigate("/add-vehicle");
      }
    };
    fetchData();
  }, [id, navigate, dispatch]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const fileRef = ref(storage, `vehicles/images/${file.name}`);
    const uploadTask = uploadBytesResumable(fileRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {},
      (error) => {
        console.error("Upload error:", error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          setAddVehicle((prev) => ({
            ...prev,
            vehicleImage: url,
          }));
        });
      }
    );
  };

  const handleDocumentUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setIsUploading(true);

    const fileRef = ref(storage, `vehicles/documents/${file.name}`);
    const uploadTask = uploadBytesResumable(fileRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {},
      (error) => {
        console.error("Document Upload Error:", error);
        setIsUploading(false);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          setAddVehicle((prev) => ({
            ...prev,
            vehicleDocument: url,
          }));
        });
        setIsUploading(false);
      }
    );
  };

  const handleRemoveVehicleImage = () => {
    setAddVehicle((prev: any) => ({
      ...prev,
      vehicleImage: "",
    }));
  };

  const handleRemoveVehicleDocument = () => {
    setAddVehicle((prev: any) => ({
      ...prev,
      vehicleDocument: "",
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const {
        registrationNumber,
        vehicleName,
        model,
        chassisNo,
        engineNo,
        manufacturedBy,
        vehicleType,
        vehicleColor,
        localvideoUrl,
        vehicleImage,
        vehicleDocument,
        vehicleTraccarDeviceId,
        company,
      } = addVehicle;
      if (
        registrationNumber == "" ||
        vehicleName == "" ||
        model == "" ||
        chassisNo == "" ||
        engineNo == "" ||
        manufacturedBy == "" ||
        vehicleType == "" ||
        vehicleColor == "" ||
        vehicleImage == "" ||
        vehicleDocument == "" ||
        localvideoUrl == "" ||
        !company?.companyId
      ) {
        toast.error("Please fill all the fields!");
      } else {
        if (isEdit) {
          const res: any = await dispatch(editVehicle(addVehicle));
          toast.success("Vehicle Edited!");
          navigate("/vehicle-list");
        } else {
          const res: any = await dispatch(addNewVehicle(addVehicle));
          if (res.data && res.isSuccess) {
            toast.success("Vehicle added!");
            navigate("/vehicle-list");
          } else {
            toast.error("User Not added!");
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const navigateTodvehicleList = () => {
    navigate("/vehicle-list");
  };

  const handleChangeForCompany = (e: any) => {
    const { value } = e.target;
    setCompanyId(value);
    if (!value) {
      setAddVehicle({
        ...addVehicle,
        company: {
          companyId: "",
          companyName: "",
        },
      });
      return;
    }
    const selectedCompany: any = allCompany.find(
      (company: any) => company._id === value
    );

    if (selectedCompany) {
      setAddVehicle({
        ...addVehicle,
        company: {
          companyId: selectedCompany?._id,
          companyName: selectedCompany?.companyName,
        },
      });
    }
  };

  const renderField = (
    label: string,
    required: boolean,
    field: React.ReactNode
  ) => (
    <Box>
      <FormLabel label={label} required={required} />
      {field}
    </Box>
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "transparent",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: -50,
          right: -50,
          width: 500,
          height: 500,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(124,109,255,0.05) 0%, transparent 70%)",
          pointerEvents: "none",
        },
      }}
    >
      <ToastContainer />
      <Card
        sx={{
          maxWidth: 1900,
          mx: "auto",
          mt: 4,
          mb: 4,
          borderRadius: 4,
          boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
          border: "1px solid #eef0f5",
          position: "relative",
          zIndex: 1,
        }}
      >
        <CardContent sx={{ p: 4 }}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 1,
            }}
          >
            <Box>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, color: "#1e90ff" }}
              >
                {isEdit ? "Edit Vehicle" : "Add New Vehicle"}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Fill in the details to add a new vehicle to your fleet.
              </Typography>
            </Box>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={navigateTodvehicleList}
              sx={{
                borderColor: "#d0d0d0",
                color: "#555",
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.8rem",
                letterSpacing: "0.5px",
                px: 2,
                py: 1,
                "&:hover": {
                  borderColor: "#999",
                  backgroundColor: "#f9f9f9",
                },
              }}
            >
              BACK TO LIST
            </Button>
          </Box>

          <Box sx={{ borderBottom: "1px solid #eef0f5", my: 2 }} />

          {/* Form Grid */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: 2,
            }}
          >
            {/* Vehicle Name */}
            {renderField("Vehicle Name", true,
              <TextField
                fullWidth
                required
                placeholder="Enter vehicle name"
                name="vehicleName"
                value={addVehicle.vehicleName}
                onChange={handleChange}
                sx={textFieldSx}
              />
            )}

            {/* Registration Number */}
            {renderField("Registration Number", true,
              <TextField
                fullWidth
                required
                placeholder="e.g. LEC-1234"
                name="registrationNumber"
                value={addVehicle.registrationNumber}
                onChange={handleChange}
                error={
                  addVehicle.registrationNumber !== "" &&
                  !REGEX.test(addVehicle.registrationNumber)
                }
                helperText={
                  addVehicle.registrationNumber !== "" &&
                  !REGEX.test(addVehicle.registrationNumber)
                    ? "Valid formats: ABC-123, ABC-1234, ABC 123, 123–9999999"
                    : ""
                }
                sx={textFieldSx}
              />
            )}

            {/* Chassis No */}
            {renderField("Chassis No", true,
              <TextField
                fullWidth
                required
                placeholder="Enter chassis number"
                name="chassisNo"
                value={addVehicle.chassisNo}
                onChange={handleChange}
                sx={textFieldSx}
              />
            )}

            {/* Model */}
            {renderField("Model", true,
              <TextField
                fullWidth
                required
                placeholder="Enter model"
                name="model"
                value={addVehicle.model}
                onChange={handleChange}
                sx={textFieldSx}
              />
            )}

            {/* Manufactured By */}
            {renderField("Manufactured By", true,
              <TextField
                fullWidth
                required
                placeholder="Enter manufacturer name"
                name="manufacturedBy"
                value={addVehicle.manufacturedBy}
                onChange={handleChange}
                sx={textFieldSx}
              />
            )}

            {/* Engine No */}
            {renderField("Engine No", true,
              <TextField
                fullWidth
                required
                placeholder="Enter engine number"
                name="engineNo"
                value={addVehicle.engineNo}
                onChange={handleChange}
                sx={textFieldSx}
              />
            )}

            {/* Vehicle Color */}
            {renderField("Vehicle Color (To show in Map)", true,
              <TextField
                select
                fullWidth
                required
                name="vehicleColor"
                value={addVehicle.vehicleColor}
                onChange={handleChange}
                sx={selectSx}
                slotProps={{
                  select: {
                    MenuProps: {
                      PaperProps: {
                        style: {
                          maxHeight: 250,
                          width: 250,
                        },
                      },
                    },
                  },
                }}
              >
                <MenuItem value="">Select color</MenuItem>
                {carColors.map((color) => (
                  <MenuItem key={color.value} value={color.value}>
                    <Box
                      sx={{
                        width: 20,
                        height: 20,
                        backgroundColor: color.value,
                        border: "1px solid #ccc",
                        borderRadius: "50%",
                        display: "inline-block",
                        mr: 1,
                        mb: "-5px",
                      }}
                    />
                    {color.name}
                  </MenuItem>
                ))}
              </TextField>
            )}

            {/* Video URL */}
            {renderField("Video URL", false,
              <TextField
                fullWidth
                placeholder="https://example.com/vehicle-video"
                name="localvideoUrl"
                value={addVehicle?.localvideoUrl}
                onChange={handleChange}
                sx={textFieldSx}
              />
            )}

            {/* Select Company */}
            {renderField("Select Company", true,
              <Autocomplete
                options={allCompany}
                getOptionLabel={(option: any) => option.companyName}
                value={
                  allCompany.find(
                    (v: any) => v._id === addVehicle.company?.companyId
                  ) || null
                }
                onInputChange={(event, newInputValue) => {
                  setSearchCompany(newInputValue);
                }}
                onChange={(event, newValue: any) => {
                  if (newValue) {
                    handleChangeForCompany({
                      target: { value: newValue._id },
                    });
                  } else {
                    handleChangeForCompany({
                      target: { value: "" },
                    });
                  }
                }}
                clearOnEscape
                ListboxProps={{
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    "& .MuiAutocomplete-option": {
                      color: "#000",
                    },
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={`Search or select ${schoolLabel}`}
                    sx={textFieldSx}
                  />
                )}
              />
            )}

            {/* Vehicle Type */}
            {renderField("Vehicle Type", true,
              <TextField
                select
                fullWidth
                required
                name="vehicleType"
                value={addVehicle.vehicleType}
                onChange={handleChangeForVehicleType}
                sx={selectSx}
                slotProps={{
                  select: {
                    MenuProps: {
                      PaperProps: {
                        style: {
                          maxHeight: 250,
                        },
                      },
                    },
                  },
                }}
              >
                <MenuItem value="">Select vehicle type</MenuItem>
                <MenuItem value="Car">Car</MenuItem>
                <MenuItem value="motorcyle">Motorcycle</MenuItem>
                <MenuItem value="bus">Bus</MenuItem>
                <MenuItem value="taxi">Taxi</MenuItem>
              </TextField>
            )}
          </Box>

          {/* File Uploads Section */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: 3,
              mt: 3,
            }}
          >
            {/* Vehicle Image */}
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, color: "#344054", mb: 1 }}>
                Vehicle Image <span style={{ color: "red" }}>*</span>
              </Typography>
              {!addVehicle.vehicleImage ? (
                <Box
                  component="label"
                  sx={{ cursor: "pointer", display: "block" }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    hidden
                  />
                  <UploadBox
                    icon={<CloudUploadIcon sx={{ fontSize: 36 }} />}
                    title="UPLOAD VEHICLE IMAGE"
                    subtitle="JPG, PNG or WEBP (Max. 5MB)"
                  />
                </Box>
              ) : (
                <Box
                  sx={{
                    position: "relative",
                    border: "1px solid #e0e0e0",
                    borderRadius: "12px",
                    overflow: "hidden",
                    p: 1,
                  }}
                >
                  <IconButton
                    onClick={handleRemoveVehicleImage}
                    sx={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      backgroundColor: "rgba(255,255,255,0.9)",
                      "&:hover": { backgroundColor: "#ffebee" },
                      zIndex: 1,
                    }}
                    size="small"
                  >
                    <MdDelete style={{ color: "#ef4444", fontSize: 18 }} />
                  </IconButton>
                  <img
                    src={addVehicle.vehicleImage}
                    alt="Vehicle"
                    style={{
                      width: "100%",
                      height: 160,
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                </Box>
              )}
            </Box>

            {/* Vehicle Document */}
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600, color: "#344054", mb: 1 }}>
                Vehicle Document <span style={{ color: "red" }}>*</span>
              </Typography>
              {!addVehicle.vehicleDocument ? (
                <Box
                  component="label"
                  sx={{ cursor: "pointer", display: "block" }}
                >
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleDocumentUpload}
                    hidden
                  />
                  <UploadBox
                    icon={<InsertDriveFileIcon sx={{ fontSize: 36 }} />}
                    title="UPLOAD DOCUMENT"
                    subtitle="PDF, JPG or PNG (Max. 10MB)"
                    disabled={isUploading}
                  />
                  {isUploading && (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                      <CircularProgress size={24} />
                    </Box>
                  )}
                </Box>
              ) : (
                <Box
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "12px",
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "#f8f9fc",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <InsertDriveFileIcon sx={{ color: "#7c6dff" }} />
                    <Typography
                      variant="body2"
                      component="a"
                      href={addVehicle.vehicleDocument}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: "#2196f3",
                        fontWeight: 500,
                        textDecoration: "none",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      View Uploaded Document
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={handleRemoveVehicleDocument}
                    size="small"
                    sx={{
                      "&:hover": { backgroundColor: "#ffebee" },
                    }}
                  >
                    <MdDelete style={{ color: "#ef4444", fontSize: 18 }} />
                  </IconButton>
                </Box>
              )}
            </Box>
          </Box>

          {/* Submit Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 4,
            }}
          >
            <Button
              variant="contained"
              startIcon={
                isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <DirectionsCarIcon />
                )
              }
              onClick={handleSubmit}
              disabled={isLoading}
              sx={{
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                px: 4,
                py: 1.2,
                backgroundColor: "#2563EB",
                "&:hover": {
                  backgroundColor: "#1976d2",
                },
              }}
            >
              {isLoading
                ? isEdit
                  ? "Editing..."
                  : "Adding..."
                : isEdit
                ? "Edit Vehicle"
                : "Add Vehicle"}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AddVehicle;
